import { v4 } from 'uuid';

import {
  DocumentMessage,
  DocumentResponse,
} from '../use-document-search.types';

interface UpdateMessageProps {
  messages: DocumentMessage[];
  message: Partial<DocumentMessage>;
}

export const createNewMessage = (
  message: Partial<DocumentMessage>,

  documents?: string[]
): DocumentMessage => {
  const {
    id = v4(),
    question = '',
    status = 'pending',
    reply = [],
    hasSeen = false,
    type = 'alfred',
  } = message;

  // WORKAROUND FOR DOCUMENT ASSISTANT API, TO KEEP UNTIL API IS FIXED
  // REMOVED APPENDED "[[DOCUMENT_NAME]]" TO QUESTION
  const parsedQuestion = question.split('[[')[0];

  return {
    id,
    question: parsedQuestion,
    status,
    reply,
    hasSeen,
    type,

    documents,
  };
};

export const updateMessage = ({
  messages,
  message,
}: UpdateMessageProps): DocumentMessage[] => {
  const existingMessageIndex = messages.findIndex(m => m.id === message.id);
  const updatedMessages = [...messages];
  updatedMessages[existingMessageIndex] = {
    ...updatedMessages[existingMessageIndex],
    ...message,
  };
  return updatedMessages;
};

export const appendReply = (
  messages: DocumentMessage[],
  { id, reply }: { id: string; reply: DocumentResponse[] }
): DocumentMessage[] => {
  return messages?.map(message => {
    if (message.id === id) {
      return { ...message, reply: [...message.reply, ...reply] };
    }

    return message;
  });
};
